import { handleActions } from '@gef-ui/utils/fsaActions';
import concat from "ramda/es/concat";
import filter from "ramda/es/filter";
import keys from "ramda/es/keys";
import map from "ramda/es/map";
import mergeWith from "ramda/es/mergeWith";
import omit from "ramda/es/omit";
import propEq from "ramda/es/propEq";
import reject from "ramda/es/reject";
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
import { merge } from 'rxjs';
import { filter as rxFilter, scan, shareReplay } from 'rxjs/operators';
import { metaRapid } from '../../../utils/data';
import { actionNames as controlActions, initGlobalErrors } from '../../transfer/control';
import { actionNames as transmissionActions, validationRunner } from '../../transfer/transmission';
import { filterByActionType, skipWhenStateEqual } from '../../utils';
const asyncPropTruthy = propEq(true, 'async');
const scanReducer = (reducerHandler)=>handleActions({
        [controlActions.INIT_GLOBAL_ERRORS]: (_state, action)=>action.payload,
        [controlActions.RESET_FORM]: ()=>{},
        [transmissionActions.UPDATE_VALIDATION_RESULT]: (state, { payload, meta })=>{
            const asyncValidationsErrors = map(filter(asyncPropTruthy), state);
            const syncValidationsErrors = map(reject(asyncPropTruthy), state);
            const payloadWithoutEmpty = reject(isNilOrEmpty, payload);
            const omitPayloadKeys = omit(keys(payload));
            if (meta.runner === validationRunner.ALL) {
                return {
                    ...omitPayloadKeys(state),
                    ...payloadWithoutEmpty
                };
            }
            const stateWithoutNewFields = omitPayloadKeys(meta.runner === validationRunner.ASYNC ? asyncValidationsErrors : syncValidationsErrors);
            const preservedValidationState = meta.runner === validationRunner.ASYNC ? syncValidationsErrors : asyncValidationsErrors;
            return mergeWith(concat, preservedValidationState, {
                ...stateWithoutNewFields,
                ...payloadWithoutEmpty
            });
        },
        ...reducerHandler
    }, {});
export default (({ control$ }, { createInputs = [], reducerHandler = {} } = {}, initState = {})=>{
    const extensionInputs$ = map((ext)=>ext({
            control$
        }), createInputs);
    const globalErrors$ = merge(control$.pipe(filterByActionType(controlActions.INIT_GLOBAL_ERRORS, controlActions.RESET_FORM)), control$.pipe(filterByActionType(transmissionActions.UPDATE_VALIDATION_RESULT), rxFilter((action)=>!metaRapid(action))), ...extensionInputs$).pipe(scan(scanReducer(reducerHandler), {}), skipWhenStateEqual(), shareReplay(1));
    globalErrors$.subscribe();
    // po prve se inicializuje pro skipWhenStateEqual. Urcite pujde vyresit lepe :)
    control$.next(initGlobalErrors({}));
    control$.next(initGlobalErrors(initState));
    return globalErrors$;
});
